<template>
  <div class="inline-help-modal" v-if="showInlineHelp">
    <div class="modalHeader" style="border-radius: 9px 9px 0px 0px !important;">
      <span class="title">Question Help</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label for="separator"><b>Separator</b></label>
        <select id="separator" v-model="separatorSelected" class="tool">
          <option v-for="(option, index) in optionsSeparator" :key="index">
              {{ option }}
          </option>
        </select>
        <br>
        <br>
        <label for="labelRange"><b>Label Range</b></label>
        <input id="labelRange" type="text" v-model="toLabel" :bind="parseText" class="tool">
        <br>
        <div v-if="checkBoxExcludeModel">
          <label for="excludeModelFields"><b>Exlude Model Fields</b></label>
          <input v-model="checked" id="excludeModelFields" type="checkbox"/>
        </div>
        <br>
        <p>{{ text }}</p>
      </div>
      <hr>
      <h1 v-if="indiceProcessing" class="msg-process">{{ msgProcessing }}</h1>
      <spinner class="spinner" v-show="loading"></spinner>
      <div v-if="inResult" id="result-inline-help">
        <label v-if="label !== '' && loading === false && inlineHelp !== ''" for="textLabel">Label:</label>
        <br>
        <p id="textLabel" class="resalt">{{ label }}</p>
        <br>
        <label v-if="inlineHelp !== '' && loading === false" for="textInlineHelp">Inline Help:</label>
        <br>
        <p id="textInlineHelp" class="resalt">{{ inlineHelp }}</p>
      </div>
      <div class="button-box float-right">
        <button class="btn btn-success" v-if="btnParse && toLabel !== ''" @click="parseData">Parse</button>
      </div>
      <div class="button-finish">
        <button class="btn btn-primary btn-lg btn-block" v-if="btnFinish && loading === false" @click="closeModal">Finish</button>
      </div>

    </div>
  </div>
</template>

<script>
import Spinner from './Spinner.vue'

export default {
  name: 'inline-help-modal',

  components: {
    Spinner
  },

  data () {
    return {
      showInlineHelp: false,
      optionsSeparator: ['.', ',', '-'],
      text: '',
      label: '',
      toLabel: '4',
      inlineHelp: '',
      separatorSelected: '.',
      questionnaireId: '',
      fieldName: '',
      allInlineHelp: [],
      loading: false,
      btnParse: false,
      btnFinish: false,
      msgProcessing: 'Processing...',
      indiceProcessing: false,
      inResult: false,
      checked: true,
      checkBoxExcludeModel: false
    }
  },

  mounted () {
    let that = this
    this.$bus.on('sendInlineHelp', this.originDesc)
    this.$on('showInlineHelp', function () {
      that.showInlineHelp = true
      that.text = ''
      that.label = ''
      that.toLabel = '4'
      that.inlineHelp = ''
      that.questionnaireId = ''
      that.fieldName = ''
      that.allInlineHelp = []
      that.loading = false
      that.btnParse = false
      that.btnFinish = false
      that.msgProcessing = 'Processing...'
      that.indiceProcessing = false
      that.inResult = false
      that.checked = true
      that.checkBoxExcludeModel = false
    })
  },
  computed: {
    parseText () {
      let dataText = {
        text: this.text,
        toLabel: this.toLabel,
        separator: this.separatorSelected
      }
      let objLabel = this.$store.getters.getInlineHelp(dataText)
      if (objLabel === undefined || objLabel === null) return
      this.label = objLabel.label
      this.inlineHelp = objLabel.inlineHelp
      this.btnParse = true
    }
  },
  methods: {
    originDesc (fieldData) {
      this.parseInlineHelp = true
      if (fieldData.one) {
        this.inResult = true
        this.questionnaireId = fieldData.questionnaireId
        this.fieldName = fieldData.name
        this.text = fieldData.text
        this.allInlineHelp = []
      } else {
        this.allInlineHelp = fieldData
        this.btnParse = true
        this.label = 'anything'
        this.checkBoxExcludeModel = true
      }
    },

    parseData () {
      let that = this
      this.btnParse = false
      if (this.allInlineHelp.length === 0) {
        this.$store.commit('changeInlineHelp', {
          questionnaireId: this.questionnaireId,
          name: this.fieldName,
          label: this.label,
          inlineHelp: this.inlineHelp
        })
        this.$bus.emit('reloadQuestionnaire')
        this.$store.dispatch('saveTemplatePages')
        this.closeModal()
      } else {
        that.indiceProcessing = true
        that.loading = true
        setTimeout(function () {
          that.generateInliniHelp()
          that.loading = false
          that.btnFinish = true
          that.msgProcessing = 'Done'
          that.label = ''
          that.inlineHelp = ''
        }, 500)
      }
    },
    generateInliniHelp () {
      let that = this
      if (this.checked) {
        let idFieldsInlineHelp = []
        this.allInlineHelp.forEach((field) => {
          if (field.model === '') {
            idFieldsInlineHelp.push(field)
          }
        })
        this.allInlineHelp = idFieldsInlineHelp
      }
      this.allInlineHelp.forEach(field => {
        let dataText = {
          text: field.desc,
          toLabel: that.toLabel,
          separator: that.separatorSelected
        }
        let objLabel = that.$store.getters.getInlineHelp(dataText)
        if (objLabel === undefined) return
        that.label = objLabel.label
        that.inlineHelp = objLabel.inlineHelp
        that.$store.commit('changeInlineHelp', {
          questionnaireId: field.questionnaireId,
          name: field.name,
          label: that.label,
          inlineHelp: that.inlineHelp
        })
      })
      // this.$store.commit('saveInlineHelpDb')
      // this.$bus.emit('setQuestionnairesFields')
      this.$bus.emit('reloadQuestionnaire')
      this.$store.dispatch('saveTemplatePages')
    },

    closeModal () {
      this.showInlineHelp = false
      this.loading = false
      this.indiceProcessing = false
      this.btnParse = true
    }
  },

  beforeDestroy () {
    // this.$bus.$off('sendInlineHelp')
    // this.$off('showInlineHelp')
  }
}
</script>

<style lang="scss" scoped>
  .inline-help-modal {
    position: fixed;
    top: 15%;
    left: 50%;
    margin-left: -19%;
    width: 50%;
    max-width: 700px;
    min-height: 420px;
    max-height: 90%;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;

    .tool {
      margin-left: 20px;
      background-color: #FFF;
    }

    .resalt {
      color: red
    }

    .msg-process {
      text-align: center;
      color: green;
    }

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }

  .button-box {
    float: right;
    margin-right: 30px;
    margin-bottom: 20px;
    .btn {
      margin-left: 10px;
    }

    .button-finish {
      padding: 5px;
      margin-bottom: 5px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/InlineHelpModal.vue